/* eslint-disable @typescript-eslint/no-unused-vars */
import { IUseLoyaltyRewards, UseLoyaltyRewards } from 'state/loyalty/hooks/types';
import noop from 'utils/noop';

export const useLoyaltyRewards: UseLoyaltyRewards = () => {
  return {
    appliedLoyaltyRewards: {},
    availableLoyaltyRewardsMap: {},
    appliedLoyaltyRewardsArray: null,
    getAvailableRewardFromCartEntry: _cartEntry => undefined,
    resetLoyaltyRewardState: noop,
    removeAppliedReward: _arg => {},
    setIsPricingRewardApplication: _arg => {},
    isPricingRewardApplication: false,
  } as IUseLoyaltyRewards;
};
